import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import InsightDetailPage from "@/pages/InsightDetail";

export const Route = createFileRoute("/$lang/analyses/$slug")({
  head: ({ params }) => pageHead(params.lang, "article", params.slug),
  component: InsightDetailPage,
});
